export default "__VITE_ASSET__6a207d2d__"